import { msg } from '@lingui/core/macro';
import { TTime } from 'types';

export const times = (): TTime[] => [
  {
    id: 'asap',
    label: msg`As soon as possible`,
  },
  {
    id: '09:00:00Z',
    label: msg`9am - 10am`,
  },
  {
    id: '10:00:00Z',
    label: msg`10am - 11am`,
  },
  {
    id: '11:00:00Z',
    label: msg`11am - 12pm`,
  },
  {
    id: '12:00:00Z',
    label: msg`12pm - 1pm`,
  },
  {
    id: '13:00:00Z',
    label: msg`1pm - 2pm`,
  },
  {
    id: '14:00:00Z',
    label: msg`2pm - 3pm`,
  },
  {
    id: '15:00:00Z',
    label: msg`3pm - 4pm`,
  },
  {
    id: '16:00:00Z',
    label: msg`4pm - 5pm`,
  },
  {
    id: '17:00:00Z',
    label: msg`5pm - 6pm`,
  },
];

export const isWeekday = (date: Date) => {
  const day = date.getDay();
  return day !== 0 && day !== 6;
};

export const timeOptionIsEarlierThanCurrentTime = (
  id: string,
  selectedDate: Date | null,
) => {
  const today = new Date();

  if (id === 'asap') {
    return false;
  }

  if (selectedDate && today > selectedDate) {
    const currentHours = ('0' + today.getHours().toString()).slice(-2);
    const timeOptionInHours = id?.split(':', 1)[0];
    return currentHours >= timeOptionInHours;
  }

  return false;
};
